import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {LoginGuard} from './_helpers/login.guard';
import {LandingComponent} from './modules/user/landing/landing.component';
import {OnBoardingComponent} from './modules/user/on-boarding/on-boarding.component';
import {IntroComponent} from './modules/intro/intro.component';
import {InvisibleCityComponent} from './modules/user/projects/invisible-city/invisible-city.component';
import {LogOutComponent} from './components/log-out/log-out.component';
import {AboutUsComponent} from './components/about-us/about-us.component';
import {TermsAndConditionComponent} from './components/terms-condition/terms-condition.component';
import {AddReportComponent} from './modules/user/auth/reports/add-report/add-report.component';
import {YouActAddReportComponent} from './modules/user/auth/reports/you-act-add-report/you-act-add-report.component';
import {LandingPreviewComponent} from './components/landing-preview/landing-preview.component';
import {MapLandingComponent} from './modules/tabs/map-landing/map-landing.component';
import {RedirectService} from './_services/redirect.serivce';
import {HandleWildCardComponent} from './components/handle-wild-card.component';
import {ProfileComponent} from './modules/user/auth/profile/profile.component';
import {SurveyComponent} from './modules/user/auth/reports/survey/survey.component';
import {FeedbackComponent} from './components/feedback/feedback.component';
import {AddSiteComponent} from './components/add-site/add-site.component';
import {PrivacyComponent} from './components/privacy/privacy.component';


const routes: Routes = [
  {
    path: 'kitchen-sink',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    component: LandingPreviewComponent
    // redirectTo: 'landing',
    // pathMatch: 'full'
  },
  {
    path: 'map',
    component: MapLandingComponent
  },
  {
    path: 'add-site',
    component: AddSiteComponent
  },
  {
    path: 'intro',
    component: IntroComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'on-boarding',
    component: OnBoardingComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'project/:project',
    component: InvisibleCityComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'view-report/:title',
    component: InvisibleCityComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'about',
    component: AboutUsComponent
  },
  {
    path: 'terms',
    component: TermsAndConditionComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyComponent
  },
  {
    path: 'profile',
    component: ProfileComponent
  },
  {
    path: 'log-out',
    component: LogOutComponent
  },
  {
    path: 'user/auth',
    loadChildren: () => import('./modules/user/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'add-report',
    component: AddReportComponent
  },
  {
    path: 'survey',
    component: SurveyComponent
  },
  {
    path: 'feedback',
    component: FeedbackComponent
  },
  {
    path: 'your-act-add-report',
    component: YouActAddReportComponent
  },
  {
    path: '**',
    component: HandleWildCardComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}

